import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { EntityDataServiceAccessorService } from '@pit/core-data';
import { EntityStoreEffects } from '@pit/core-store';
import { IDtoDepot } from '@pit/frontend-model';
import { DtoDepotStoreFactory } from './dto.depot.store.factory';
import { Observable } from 'rxjs';
import { Action } from '@ngrx/store';

@Injectable()
export class DtoDepotEffects extends EntityStoreEffects<IDtoDepot> {

    constructor(actions$: Actions, dataServiceAccessor: EntityDataServiceAccessorService) {
        super('dto.depot', actions$, DtoDepotStoreFactory.instance, dataServiceAccessor);
    }

    loadDepotsForMandator$: Observable<Action> = DtoDepotStoreFactory.instance.getEffect('get.by.mandator')(this.actions$, this.dataServiceAccessor);

}
